module.exports = __webpack_public_path__ + "static/media/mainBgOne.90c83027.png";